import { useQuery } from '@tanstack/react-query'

import { adminUsersApi, type AdminUsersParams } from '@/features/admin/api/users.api'

export function useAdminUsersQuery(params: AdminUsersParams = {}) {
  return useQuery({
    queryKey: ['admin', 'users', params],
    queryFn: () => adminUsersApi.list(params),
  })
}
